import React, {useState, useEffect} from "react";
import './home.css';
import { useLicenseService } from "../service/service";

var fetchExecutado = false;
const MONITORAMENTO = [
    { id: "RWIDCE", name: "Cockpit web" },
    { id: "RWCOCKPIT", name: "Cockpit desktop" },
    { id: "RWCHECKOUT", name: "Checkout desktop" },
    { id: "RWPORTAL", name: "Portal de exames" },
    { id: "ANATOWEB", name: "Anatomia patológica" },
    { id: "PSDCMSRV", name: "PACS Server" },
];

const Home = () => {
    const licenseService = useLicenseService();
    const [licenseStatus, setLicenseStatus] = useState("INDEFINIDO");
    const [customerId, setCustomerId] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [customerCNPJ, setCustomerCNPJ] = useState("");

    const getSistemasMonitorados = () =>{ 
        return MONITORAMENTO.map(x => {
            return {...x, flag: "orange", desc: "INDEFINIDO"}
        });
    };

    const [sistemas, setSistemas] = useState(getSistemasMonitorados());
    const fetchStatus = async () => {
        let response = await licenseService.status();
        let json = await response.json();
        return json.message;
    }

    const fetchCustomerInfo = async () => {
        let response = await licenseService.customerInfo();
        let json = await response.json();
        return json;
    }

    const fetchLicense = async (sistema) =>{
        let data = {
            "Aplicativo": sistema,
            "Modulo": sistema,
            "SessionID": "vivace.manager."+sistema
        };
    
        try {          
            let validateResponse = await licenseService.validate(data);
            let validateJson = await validateResponse.json();
            if (validateJson.success !== true) {
                return {
                    flag: "red",
                    desc: "Não foi possível obter uma licença\n" + validateJson.message
                };
            }
        } catch (error) {
            console.error(error);
            return {
                flag: "red",
                desc: "Erro ao obter licença. Verifique o log."
            };
        }

        try {
            let releaseResponse = await licenseService.release(data);
            let releaseJson = await releaseResponse.json();            
            if (releaseJson !== true) {
                return {
                    flag: "red",
                    desc: "Não foi possível liberar a licença\n" + releaseJson.message
                };
            }
        } catch (error) {
            console.error(error);
            return {
                flag: "red",
                desc: "Erro ao liberar licença. Verifique o log."
            };
        }

        return {
            flag: "green",
            desc: "Licença obtida com sucesso"
        };
    }

    const checkLicensaDosSistemas = async () => {
        debugger
        let result = [];

        for (let i = 0; i < sistemas.length; i++) {
            const sis = sistemas[i];
            let status = await fetchLicense(sis.id);
            result.push({
                id: sis.id,
                name: sis.name,
                flag: status.flag,
                desc: status.desc
            });
        }

        return result;

    };

    useEffect( () => {        
        if (fetchExecutado === true){
            return;
        }

        fetchExecutado = true;
        fetchStatus().then(x => setLicenseStatus(x));
        fetchCustomerInfo().then(x => {
            setCustomerId(x.id);
            setCustomerName(x.name);
            setCustomerCNPJ(x.cnpj);
        });

        checkLicensaDosSistemas().then(x => setSistemas(x));            
    });
        
    const serverStatusColor = () => {
        if (serverStatusText() === "ON-LINE"){
            return "display-green";
        }
        if (serverStatusText() === "INDEFINIDO"){
            return "display-orange";
        }
        return "display-red";
    }

    const serverStatusText = () => {
        if (licenseStatus.includes("ON-LINE") === true)
        {
            return "ON-LINE";
        }

        return licenseStatus;
    }

    const buildCustomer = () => {
        return (
            <span className="info">
                <strong>
                    {customerId} - {customerName} - {customerCNPJ}
                </strong>
            </span>        
        )
    }

    const buildServerStatus = () => {
        return (
            <strong className={`${serverStatusColor()}`} >{serverStatusText()}</strong>        
        )
    }

    const buildSistemas = () => {

        return sistemas.map((sis, i) => {
            return(
                <>
                    <div key={i} className={`display-${sis.flag}`}>
                        <strong>{sis.id} - {sis.name}</strong>
                    </div>
                    <div>{sis.desc}</div>                
                </>
            );    
        });
    }
    
    return(
        <div>
            <div className="bem-vindo">Bem vindo ao Vivace Manager!</div>
            <div className="info">Se você está vendo esta página é sinal que ele está instalado e ativo.</div>
            <div className="info">Licenciado para: {buildCustomer()}</div>            
            <div className="info">Status o servidor de licenças: {buildServerStatus()} </div>            
            <div className="info">Status das licenças por sistema: </div>            
            {buildSistemas()}
        </div>
    )
}

export default Home;
